// API service for dashboard data
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class DashboardService {
  // Get dashboard statistics
  static async getDashboardStats(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/dashboard/stats`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      throw error;
    }
  }
}

export default DashboardService;
